export default "__VITE_ASSET__Dkg2hiKH__"